module.exports = __webpack_public_path__ + "img/Jojo.d2352e38.gif";